import { render, staticRenderFns } from "./EventDetailsTimeslots.vue?vue&type=template&id=942be5be&scoped=true&"
import script from "./EventDetailsTimeslots.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsTimeslots.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsTimeslots.vue?vue&type=style&index=0&id=942be5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942be5be",
  null
  
)

export default component.exports